// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeUnaffiliated = {
  ctfAuthDataContractInvalid: "CTF 当前用户权限数据合同异常，请联系管理员排查",
  eduAuthDataContractInvalid: "EDU 当前用户权限数据合同异常，请联系管理员排查",
  eduAuthMemberAccessRequired: "当前账号还未开通教育门户访问权限",
  eduDependencyDatabaseUnavailable: "数据库暂时不可用，请稍后重试",
  microLabAuthDataContractInvalid: "Micro Lab 当前用户权限数据合同异常，请联系管理员排查",
  microLabMemberContractInvalid: "Micro Lab 成员角色数据合同异常，请联系管理员排查",
  platformIntelligenceAuditTokenUsageInvalid:
    "智能中心审计令牌用量字段 {field} 不合法，请联系管理员排查",
  platformKnowledgeLibraryAuthInvalidAppSession: "当前知识库会话已失效，请重新登录",
  platformToolsLibraryContractInvalidEnum: "工具库筛选枚举值无效，请刷新后重试或联系管理员排查",
  redblueMemberContractInvalid: "RedBlue 成员角色数据合同异常，请联系管理员排查",
  toolsLibraryDownloadFilenameMissing: "工具下载响应缺少文件名，请联系管理员排查",
} as const;
